<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="550px">
      <v-card>
        <v-card-title style="padding: 10px 0 0 10px; height: 20px;">
          <v-col cols="12">
            <v-btn icon style="top: -20px; left: 10px; float: right;">
              <v-icon @click="showDialog = false">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text class="text-center" style="padding-bottom: 0;">
          <v-container>
            <p style="line-height: 30px; font-size: 24px; text-align: center; margin-bottom: 0;">Seleccione dónde quiere
              recibir el enlace para acceder a esta notificación</p>
            <p style="font-size: 16px; text-align: center; margin-top: 20px; margin-bottom: 0;">{{ numeroReferencia }}</p>
            <v-row>
              <v-col cols="12">
                <v-img position="center" :src="require('@Base/assets/link.svg')" contain style="height: 80px;" />
              </v-col>
            </v-row>

            <v-row style="margin-top: 0; margin-left: 20px; padding: 0;">
              <v-col cols="12" style="padding: 0;">
                <v-radio-group v-model="canal" column :rules="[validationRules.required]">
                  <p v-if="emails.length > 0">En un correo electrónico enviado a esta dirección:</p>
                  <p v-for="email in emails" :key="email">
                    <v-radio :value="email">
                      <template v-slot:label>
                        <div><strong>{{ ofuscarEmail(email) }}</strong></div>
                      </template>
                    </v-radio>
                  </p>
                  <p v-if="telefonos.length > 0">En un SMS enviado a este número:</p>
                  <p v-for="telefono in telefonos" :key="telefono">
                    <v-radio :value="telefono">
                      <template v-slot:label>
                        <div><strong>{{ ofuscarTelefono(telefono) }}</strong></div>
                      </template>
                    </v-radio>
                  </p>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" style="padding: 0;">
                <v-alert color="#124D91" text style="margin: 0 10px 30px 10px; text-align: left;">
                  <img src="../assets/warning.svg" height="30px" style="margin: 0 25px 0 10px; float: left;" />
                  <span style="color: #595959; font-size: 1em; padding-left: 72px; display: block;">
                    <strong>¿No tiene acceso a ninguno de estos canales de comunicación?</strong><br>
                    Cumplimente <a href="https://umivale.es/dam/varios/prestaciones/datos-gestion-PECATA.pdf"
                      target="_blank" @click.stop>este formulario</a>
                    y envíelo firmado a <strong>ceseautonomocovid@umivaleactiva.es</strong> junto a una copia del DNI o
                    NIE de los firmantes.
                  </span>
                </v-alert>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" style="padding: 0;">
                <v-btn :disabled="!canal" color="primary" class="btn-next" @click="enviarEnlace">
                  Recibir enlace
                </v-btn>
              </v-col>
              <v-col cols="12" style="margin: 10px 0; padding: 0;">
                <v-btn color="#124D91" text class="btn-link" @click="showDialog = false">
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from '../services/solicitudService'
import StepBase from './common/StepBase.js'

export default {
  name: 'CanalesAccesoDialog',
  mixins: [StepBase],
  data() {
    return {
      showDialog: false,
      idSolicitante: null,
      numeroReferencia: null,
      emails: [],
      telefonos: [],
      canal: null,
    }
  },
  methods: {
    open: function (solicitante, movilesContacto) {
      this.idSolicitante = solicitante.idSolicitante;
      this.numeroReferencia = solicitante.numeroReferencia;

      this.emails = [];
      if (solicitante.email) {
        this.emails.push(solicitante.email);
      }
      if (solicitante.despachoEmail) {
        this.emails.push(solicitante.despachoEmail);
      }

      this.telefonos = [...movilesContacto];
      /*this.telefonos = [];
      if (solicitante.movil) {
        this.telefonos.push(solicitante.movil);
      }
      if (solicitante.despachoMovil) {
        this.telefonos.push(solicitante.despachoMovil);
      }*/

      this.showDialog = true;
    },
    ofuscarEmail(value) {
      var emailParts = value.split("@");
      return emailParts[0].substring(0, 3) + "***@***" + emailParts[1].substring(3);
    },
    ofuscarTelefono(value) {
      return value.substring(0, 2) + "*****" + value.substring(7);
    },
    enviarEnlace() {
      api.enviarEnlace(this.idSolicitante, this.canal,
        () => {
          this.$emit('alert-event', { text: 'El enlace se ha enviado', color: 'green' });
        },
        error => {
          this.$emit('alert-event', { text: 'El enlace no se pudo enviar', color: 'red' });
          console.log(error);
        }
      );
    }
  },
}
</script>
